import { Activity } from 'react'

import { BranchesPanel } from '../../components/branchesPanel/BranchesPanel'
import { ConfigurationItemsTree } from '../../components/configurationItemsTree/ConfigurationItemsTree'
import { WorkspacesPanel } from '../../components/workspacesPanel/WorkspacesPanel'
import { useLayoutContext } from '../../context/layoutContext'

export const LeftSideBar = () => {
  const {
    preferences: { leftSidebar },
    persona,
  } = useLayoutContext()

  const isConfigurationItemsTreeVisible = leftSidebar === 'picker'

  return (
    <div className="flex size-full flex-col overflow-hidden">
      <Activity mode={isConfigurationItemsTreeVisible ? 'visible' : 'hidden'}>
        <ConfigurationItemsTree isVisible={isConfigurationItemsTreeVisible} />
      </Activity>
      <Activity mode={leftSidebar === 'branches' ? 'visible' : 'hidden'}>
        <BranchesPanel />
      </Activity>
      <Activity
        mode={
          leftSidebar === 'workspaces' && persona === 'ConfigurationAdmin'
            ? 'visible'
            : 'hidden'
        }
      >
        <WorkspacesPanel />
      </Activity>
    </div>
  )
}
